import { styled, Box } from '@mui/material'

export const StyledPromtContainer = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: `50%`,
  left: `50%`,
  transform: `translate(-50%, -50%)`,
  width: '100%',
  backgroundColor: theme.palette.background.paper,
  boxShadow: theme.shadows[5],
  [theme.breakpoints.up('sm')]: {
    maxWidth: 512,
  },
  [theme.breakpoints.down('xs')]: {
    maxWidth: 'calc(328px - 32px)',
  },
}))

export const StyledPromtFooter = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-end',
  columnGap: theme.spacing(3),
  rowGap: theme.spacing(2),
  padding: theme.spacing(3),
  [theme.breakpoints.down('xs')]: {
    flexDirection: 'column-reverse',
  },
  '& .MuiButton-root': {
    minWidth: 50,
  },
}))
